import React, { useState, useEffect } from 'react';
import { fetchAuditReportsList } from '../../api/api';
import SubHeader from '../QuestionConfigure/SubHeader';
import 'react-toastify/dist/ReactToastify.css';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button
} from '@material-ui/core';
import './AuditReport.css';
import LoaderComponent from '../LoaderComponent';

const AuditLables = [{ label: "User Name", config: "user_name" }, { label: "Status", config: "status" }, { label: "Event", config: "event" }, { label: "IP Address", config: "ip_address" }, { label: "Message", config: "message" }, { label: "Time Stamp", config: "timestamp" }];
const pages = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const pageSize = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

const AuditReportsList = (props) => {

    const [state, setState] = useState({
        page: 1,
        page_size: 10,
        user_name: '',
        status: '',
        event: '',
        start_date: '',
        end_date: '',
        customer: props.match.params.id
    });
    const [auditReportData, setAuditReportData] = useState([]);
    const [isClearData, setClearData] = useState(false);
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [authEvents, setAuthEvents] = useState([]);
    const [isLoading, setLoading] = useState(false);

    const setInitialState = {
        page: 1,
        page_size: 10,
        user_name: '',
        status: '',
        event: '',
        start_date: '',
        end_date: '',
        customer: props.match.params.id
    };
    useEffect(() => {
        const id = state.customer;

        if (id) {
            fetchData();
        }
    }, []);

    useEffect(() => {
        if (isClearData) {
            fetchData();
        }
    }, [isClearData]);

    const fetchData = async () => {

        try {
            setLoading(true);
            let response = await fetchAuditReportsList(state);
            let nextPage = '';
            let previousPage = '';
            if (response && response?.next) {
                const url = new URL(response.next);
                const params = new URLSearchParams(url.search);
                nextPage = params.get('page');
            }
            if (response && response?.previous) {
                const url = new URL(response.previous);
                const params = new URLSearchParams(url.search);
                previousPage = params.get('page');
                previousPage = previousPage !== null && previousPage ? previousPage : 1
                
            }
            if (response && response?.events) {
                setAuthEvents(response.events);
            }
            setNextPage(nextPage);
            setPreviousPage(previousPage);
            setAuditReportData(response?.results);
            setClearData(false);
            setLoading(false);
        } catch (error) {
             setLoading(false);
            console.error("Error fetching data:", error);
            // Handle error as needed
        }
    };

    const HandleChange = (e) => {
        const { name, value } = e.target;
        setState((prevState) => ({
            ...prevState,
            [name]: value
        }))

    }

    const SearcData = () => {
        fetchData();
    }

    const ClearData = async () => {
        await setState({ ...setInitialState });
        setClearData(true);
    }

    const HandleNext = async () => {
        await setState((prevState) => ({ ...prevState, page: nextPage }));
        setClearData(true);
    }

    const HandlePrevious = async () => {
        await setState((prevState) => ({ ...prevState, page: previousPage }));
        setClearData(true);
    }

    const HandlePages = async (e) => {
        const { name, value } = e.target;
        await setState((prevState) => ({ ...prevState, [name]: value }));
        setClearData(true);
    }

    return (
        <div className="container-fluid mb-5" style={{ marginTop: '3rem' }}>
            <SubHeader {...props.match} title="Audit Reports" id={props.match.params.id} config={props.match.params.Config} subConfig={props.match.params.subConfig} DownloadToolConfiguration={() => { }} UploadToolConfiguration={() => { }} loadingHandler={() => { }} isLoading={() => { }} />
            <LoaderComponent isLoading={isLoading} />
            <div className="form-group field-row">
                <label className="col-sm-1 col-form-label  ">User name: </label>
                <div className="col-sm-2">
                    <input type="text" name="user_name" className="form-control" value={state.user_name} onChange={HandleChange} />
                </div>
                <label className="col-sm-1 col-form-label ">Status: </label>
                <div className="col-sm-2">
                    <select name="status" className="form-control" value={state.status} onChange={HandleChange}>
                        <option value="">Select Status</option>
                        <option key={0} value='success'>
                            Success
                        </option>
                        <option key={1} value='failed'>
                            Failed
                        </option>
                    </select>
                </div>
                <label className="col-sm-1 col-form-label  ">Event: </label>
                <div className="col-sm-2">
                    <select name="event" className="form-control" value={state.event} onChange={HandleChange}>
                        <option value="">Select Event</option>
                        {authEvents.map((item, index) => {
                            return (
                                <option key={index} value={item}>
                                    {item}
                                </option>
                            )
                        })}
                    </select>
                </div>
            </div>
            <div className="form-group field-row">
                <label className="col-sm-1 col-form-label  ">Start Date: </label>
                <div className="col-sm-2">
                    <input type="date" name="start_date" required className="form-control" value={state.start_date} onChange={HandleChange} />
                </div>
                <label className="col-sm-1 col-form-label ">End Date: </label>
                <div className="col-sm-2">
                    <input type="date" name="end_date" required className="form-control" value={state.end_date} onChange={HandleChange} />
                </div>
                <label className="col-sm-1 col-form-label  ">Page: </label>
                <div className="col-sm-1">
                    <select name="page" className="form-control" value={state.page} onChange={HandlePages}>
                        <option value="">Page</option>
                        {pages.map((item, index) => {
                            return (
                                <option key={index} value={item}>
                                    {item}
                                </option>
                            )
                        })}
                    </select> 
                </div>
                <label className="col-sm-1 col-form-label ">Records: </label>
                <div className="col-sm-1">
                    <select name="page_size" className="form-control" value={state.page_size} onChange={HandlePages}>
                        <option value="">Page Size</option>
                        {pageSize.map((item, index) => {
                            return (
                                <option key={index} value={item}>
                                    {item}
                                </option>
                            )
                        })}
                    </select>
                </div>
            </div>
            <div className="form-group field-row" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <div className="col-sm-2">
                    <button type="button" className="btn btn-primary font-weight-bold btn-block" onClick={() => ClearData()}>
                        Clear
                    </button>
                </div>
                <div className="col-sm-2">
                    <button type="button" className="btn btn-primary font-weight-bold btn-block" onClick={() => SearcData()}>
                        Search
                    </button>
                </div>
            </div>
            <TableContainer component={Paper} style={{ margin: '15px', width: 'auto' }}>
                <Table aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            {AuditLables.map((item, index) => {
                                return (
                                    <TableCell key={index}>
                                        <b>{item.label}</b>
                                    </TableCell>
                                )
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {auditReportData && auditReportData.length > 0 ? auditReportData.map((row, i) => (
                            <TableRow key={i} style={{ height: '50px' }}>
                                {AuditLables.map((item, i) => {
                                    return (
                                        <TableCell key={i} style={{ padding: '5px 15px' }} component="td" scope="row">
                                            {row[`${item.config}`]}
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                        )) : <TableRow>
                            <TableCell colSpan={2}>
                                No Records Found.
                            </TableCell>
                        </TableRow>}
                    </TableBody>
                </Table>
                <div className='PaginationRow'>
                    <div className='pageGroup'>
                        <Button disabled={!previousPage} className='btnPageStyle' onClick={() => HandlePrevious()}>Previous</Button>
                        <Button disabled={!nextPage} className='btnPageStyle' onClick={() => HandleNext()}>Next</Button>
                    </div>
                </div>
            </TableContainer>
        </div>
    );
};

export default AuditReportsList;
